// src/hooks/useBoxview.js
import { useState } from 'react';

export const useBoxview = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const openBoxview = (imageList, index = 0) => {
    // S'assurer que chaque image a une URL complète
    const formattedImages = imageList.map(img => ({
      ...img,
      url: img.url.startsWith('http') ? img.url : `${process.env.REACT_APP_UPLOADS_URL || 'https://murima.julesferry-ga.com/uploads/'}${img.url}`
    }));
    
    setImages(formattedImages);
    setCurrentIndex(index);
    setIsOpen(true);
  };

  const closeBoxview = () => {
    setIsOpen(false);
    // Ne pas vider immédiatement pour éviter le flash
    setTimeout(() => {
      setImages([]);
      setCurrentIndex(0);
    }, 300);
  };

  return {
    isOpen,
    images,
    currentIndex,
    openBoxview,
    closeBoxview
  };
};